import { BaseCardProps } from "../../interface";
import classes from "./textWithLink.module.scss";
import { LIVE_FLAG_LABEL } from "../VerticalToHorizontalCard/constants";
import classNames from "classnames/bind";
import { shouldRenderStatus } from "../../utils/core-utils";

const TextWithLink = ({ item }: BaseCardProps) => {
    const { id, title, flags } = item;

    const status = flags?.status;
    const cx = classNames.bind(classes);
    const flagClasses = cx({
        liveFlag: status?.toLowerCase() === LIVE_FLAG_LABEL,
        flag: true,
    });

    if (!id) {
        return <div></div>;
    }

    return (
        <div className={classes.card}>
            <span className={classes.label_wrap}>
                {shouldRenderStatus(item) && status ? (
                    <span className={flagClasses}>{status}</span>
                ) : null}

                <span className={classes.label_text}>{title}</span>
            </span>
        </div>
    );
};

export default TextWithLink;
